import { clientStyles } from '~/modules/covenants/CovenantsDataForm/CovenantsFormByClient/styles.ts';
import { Box, Button, Grid, Paper, Typography } from '@mui/material';
import { counterpartySelectorPaperStyle } from '~/modules/covenants/CovenantsDataForm/CovenantsFormByClient/constants.ts';
import { FormProvider } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { useMainePageForm } from '~/modules/identification/components/DataUpdate/useMainPage.ts';
import { styles as mainPage } from '~/modules/main-page/styles.ts';
import { styles as root } from '~/modules/styles.ts';
import FormAutocomplete from '~/components/FormComponents/FormAutocomplete.tsx';
import { useNavigate, useSearchParams } from 'react-router';
import { TAutocompleteOption } from '~/components/AutocompleteField/types';
import HeaderMainPage from '~/modules/main-page/HeaderMainPage/HeaderMainPage.tsx';
import Footer from '~/modules/main-page/FooterMainPage/FooterMainPage';
import { updatingDataFop, updatingDataLegalResident } from '~/modules/identification/constants.ts';
import { IdentificationType } from '../../forms/GettingStarted/types';

const DataUpdate = () => {
  const navigate = useNavigate();
  const form = useMainePageForm();

  const [searchParams] = useSearchParams();
  const isSoleTrader = searchParams.has('sole-trader');
  const [dataUpdateSelection, setDataUpdateSelection] = useState<TAutocompleteOption[]>([]);

  useEffect(() => {
    if (isSoleTrader) {
      setDataUpdateSelection(updatingDataFop);
    } else {
      setDataUpdateSelection(updatingDataLegalResident);
    }
  }, [dataUpdateSelection]);

  const onSubmit = form.handleSubmit(async () => {
    const isValid = await form.trigger('dataUpdateForms', {
      shouldFocus: true,
    });
    const values = form.getValues('dataUpdateForms');

    if (!isValid || !values?.length) {
      form.setFocus('dataUpdateForms');
      return;
    }
    navigate(`/identification/questionnaire?type=${IdentificationType.RE_IDENTIFICATION}`);
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <FormProvider {...form}>
      <Box sx={root.contentPanel}>
        <Box sx={{ minHeight: '100vh', position: 'relative' }}>
          <HeaderMainPage />
          <Box sx={clientStyles.selectorWrap}>
            <Paper
              elevation={3}
              sx={clientStyles.selectorCard}
              style={counterpartySelectorPaperStyle}
            >
              <Grid sx={mainPage.modalContent}>
                <Typography variant={'h5'} sx={{ textAlign: 'center' }}>
                  Оберіть одну або кілька причин, які ви хочете оновити
                </Typography>
                <Grid sx={{ width: '80%' }}>
                  <FormAutocomplete
                    multiple={true}
                    options={dataUpdateSelection}
                    fullWidth
                    clearValueOnReset
                    errorTouchedOnly={false}
                    variant="outlined"
                    name={'dataUpdateForms'}
                    style={{ width: '600px' }}
                    inputProps={{
                      maxLength: 20,
                      placeholder: `Оберіть варіант відповіді`,
                    }}
                  />
                </Grid>
              </Grid>
              <Box style={{ display: 'flex', justifyContent: 'center' }}>
                <Button variant={'contained'} type={'submit'} onClick={onSubmit}>
                  Продовжити
                </Button>
              </Box>
            </Paper>
          </Box>
          <Footer />
        </Box>
      </Box>
    </FormProvider>
  );
};

export default DataUpdate;
